import AgentRoutes from "../flows/agent-view/AgentRoutes";
import CompanyRoutes from "../flows/company-view/CompanyRoutes";
import EmployeeRoutes from "../flows/employee-view/EmployeeRoutes";
import LuftRoutes from "../flows/luft-view/LuftRoutes";
import { USER_ROLES } from "./UsersRoles";

export const RouteBasedInRole = {
  [USER_ROLES.COMPANY]: CompanyRoutes,
  [USER_ROLES.MASTER]: LuftRoutes,
  [USER_ROLES.AGENT]: AgentRoutes,
  [USER_ROLES.EMPLOYEE]: EmployeeRoutes,
};